export const contractTemplates = [
  {
    id: "ct1",
    title: "전속 아티스트 계약서 (표준형)",
    category: "아티스트",
    clauses: [
      "계약 기간: 3년 (양측 합의 시 1년 단위 연장)",
      "수익 배분: 음원 수익의 60%를 아티스트에게 귀속",
      "매니지먼트 독점권: 계약 기간 내 타 기획사 활동 금지",
      "홍보물 사용 권리: 아티스트 초상권은 계약 기간 내 회사가 관리",
      "계약 해지: 3개월 사전 서면 통보 필요",
      "손해배상: 일방 귀책 해지 시 잔여 계약금의 20% 위약금 발생",
    ],
    lastModified: "2026.03.01",
  },
  {
    id: "ct2",
    title: "음원 유통 계약서",
    category: "유통",
    clauses: [
      "독점 유통권: 국내 주요 음원 플랫폼 유통 독점 3년",
      "수수료: 총 음원 수익의 15% (단, 첫 3개월 프로모션 기간 20%)",
      "정산 주기: 매월 말일 정산 후 익월 15일 지급",
      "플랫폼 추가: 해외 플랫폼 추가 시 별도 협의",
      "저작권 귀속: 저작권은 원저작자에게 귀속, 인접권은 유통사",
    ],
    lastModified: "2026.02.15",
  },
  {
    id: "ct3",
    title: "뮤직비디오 제작 외주 계약서",
    category: "외주",
    clauses: [
      "납품 기한: 계약일로부터 30일 이내",
      "대금 지급: 계약금 50% 선지급, 납품 후 잔금 50%",
      "수정 횟수: 기본 2회 무료, 이후 1회당 50만원",
      "저작권 양도: 최종 납품물의 저작권 일체를 발주사에 양도",
      "지연 위약금: 납품 지연 1일당 계약금의 0.5%",
    ],
    lastModified: "2026.03.10",
  },
];

export const suspiciousContracts = [
  {
    id: "sc1",
    from: "유통사 김과장 (미래엔터미디어)",
    received: "2026.03.26 14:30",
    title: "음원 독점 유통 계약서 v2.1 (수정안)",
    status: "검토 필요",
    riskLevel: "위험",
    fullText: `본 계약서는 미래엔터미디어(이하 "유통사")와 K-ArtPEN(이하 "기획사") 간 음원 유통에 관한 계약입니다.

제1조 (계약기간) 본 계약의 기간은 계약일로부터 5년으로 하며, 별도 서면 해지 통보가 없는 경우 자동으로 5년씩 연장됩니다.

제2조 (수익 배분) 유통사는 총 음원 수익의 80%를 수취하며, 기획사에게 20%를 정산합니다. 단, 프로모션 비용은 기획사 부담으로 합니다.

제3조 (독점권) 기획사는 계약 기간 내 타 유통사를 통한 음원 발매 및 유통 행위를 일절 금지하며, 이를 위반할 시 잔여 계약금의 300%를 손해배상으로 지급해야 합니다.

제4조 (저작권) 계약 기간 내 제작·발매되는 모든 음원의 인접권 및 저작인접권은 유통사에 귀속됩니다.

제5조 (분쟁 해결) 분쟁 발생 시 유통사 소재지 법원을 전속 관할 법원으로 합니다.`,
    toxicClauses: [
      { clause: "제2조 수익 배분: 유통사 80% 수취", reason: "업계 표준(유통사 15~20%)을 4~5배 초과하는 불공정 조항", severity: "위험" },
      { clause: "제3조 위약금: 잔여 계약금의 300%", reason: "과도한 위약금으로 불공정 약관법 위반 가능성", severity: "위험" },
      { clause: "제1조 자동 갱신: 5년 자동 연장", reason: "명시적 의사 없이 자동 5년 연장은 불리한 조항", severity: "주의" },
      { clause: "제4조 저작인접권 유통사 귀속", reason: "저작인접권까지 유통사에 귀속시키는 것은 과도한 권리 이전", severity: "위험" },
    ],
  },
  {
    id: "sc2",
    from: "외주 디자이너 박윤아 (YoonArt Studio)",
    received: "2026.03.25 09:15",
    title: "앨범 커버 디자인 외주 계약서",
    status: "승인 가능",
    riskLevel: "낮음",
    fullText: `본 계약서는 YoonArt Studio(이하 "디자이너")와 K-ArtPEN(이하 "발주사") 간 디자인 외주에 관한 계약입니다.

제1조 (납품 기한) 계약일로부터 21일 이내 최종 납품합니다.

제2조 (대금) 총 계약금액은 220만원이며, 계약금 50% 선지급, 납품 완료 후 잔금 50% 지급합니다.

제3조 (수정) 기본 2회 무료 수정을 제공하며, 추가 수정은 1회당 30만원입니다.

제4조 (저작권) 최종 납품 및 잔금 지급 완료 후 저작권 일체는 발주사에 양도됩니다.`,
    toxicClauses: [],
  },
];

export const copyrightRegistrations = [
  {
    id: "cr1",
    title: "루나&스타즈 - 'Moonrise' (타이틀곡)",
    artist: "루나&스타즈",
    registrationNo: "C-2026-KAP-001",
    registeredDate: "2026.02.20",
    status: "등록 완료",
    royaltyEarned: 3800,
  },
  {
    id: "cr2",
    title: "DarkNova - 'Eclipse' (1st Single)",
    artist: "DarkNova",
    registrationNo: "C-2026-KAP-002",
    registeredDate: "2026.03.05",
    status: "등록 완료",
    royaltyEarned: 1250,
  },
  {
    id: "cr3",
    title: "봄 시즌 디지털 싱글 패키지 (3곡)",
    artist: "Various",
    registrationNo: "대기중",
    registeredDate: "-",
    status: "신청 대기",
    royaltyEarned: 0,
  },
];
